import G6, { Graph, IGroup } from '@antv/g6';
import inComing_zz_hasP_open from './imgs/inComing_zz_hasP_open.svg';
import inComing_zz_hasP_close from './imgs/inComing_zz_hasP_close.svg';
import inComing_zz_noP_open from './imgs/inComing_zz_noP_open.svg';
import inComing_zz_noP_close from './imgs/inComing_zz_noP_close.svg';
import inComing_hw_close from './imgs/inComing_hw_close.svg';
import inComing_hw_open from './imgs/inComing_hw_open.svg';
import transformer from './imgs/transformer.svg';
import gridBilling_open from './imgs/gridBilling_open.svg';
import gridBilling_close from './imgs/gridBilling_close.svg';
import outGoing_open from './imgs/outGoing_open.svg';
import outGoing_open_2 from './imgs/outGoing_open_2.svg';
import outGoing_close from './imgs/outGoing_close.svg';
import outGoing_close_2 from './imgs/outGoing_close_2.svg';
import lineGate_high_open from './imgs/lineGate_high_open.svg';
import lineGate_high_close from './imgs/lineGate_high_close.svg';
import busTie_high_qua_open from './imgs/busTie_high_qua_open.svg';
import busTie_high_qua_close from './imgs/busTie_high_qua_close.svg';
import busTie_high_noqua_open from './imgs/busTie_high_noqua_open.svg';
import busTie_high_noqua_close from './imgs/busTie_high_noqua_close.svg';
import voltageVariable_hw_close from './imgs/voltageVariable_hw_close.svg';
import voltageVariable_hw_open from './imgs/voltageVariable_hw_open.svg';
import voltageVariable_zz from './imgs/voltageVariable_zz.svg';
import low_inComing_open from './imgs/low_inComing_open.svg';
import low_inComing_close from './imgs/low_inComing_close.svg';
import low_outGoing_breaker_close from './imgs/low_outGoing_breaker_close.svg';
import low_outGoing_breaker_open from './imgs/low_outGoing_breaker_open.svg';
import low_outGoing_switch_close from './imgs/low_outGoing_switch_close.svg';
import low_outGoing_switch_open from './imgs/low_outGoing_switch_open.svg';
import low_busTie_open from './imgs/low_busTie_open.svg';
import low_busTie_close from './imgs/low_busTie_close.svg';
import { CircuitType } from '@/api/circuit';
import { keepTwoOrEmpty, keepTwoOrLine } from '@/utils/utils';

// 图片map
export const nodeImgSizeMap: Record<string, number[]> = {
  // 高压
  inComing_hasP_1: [69, 250], // 高压进线  69 250
  inComing_noP_1: [112, 282], // 高压进线  112, 282
  inComing2: [76, 202], // 高压进线  76, 202

  outGoing2: [49, 202], // 环网柜 49 202
  outGoing1: [69, 250], // 中置柜 69 250
  transformer: [89, 200], // 89 200
  gridBilling: [183, 250], // 183 250
  lineGate: [15, 202], // 15 202
  busTie: [102, 250], // 102 250
  voltageVariable1: [80, 139], // 80 139
  voltageVariable2: [54, 201], // 54 201

  // 低压
  low_inComing: [95, 282], // 95 282
  low_outGoing: [155, 99], // 155,99
  low_busTie: [96, 250], // 96,250
};

export const nodeSizeMap: Record<string, number[]> = {
  // 高压
  inComing_hasP_1: [240, 250], // 高压进线中置柜（100）  69 250
  inComing_noP_1: [280, 282], // 高压进线中置柜 112, 282
  inComing2: [220, 202], // 高压进线环网柜  76, 202

  outGoing2: [180, 202], // 环网柜（100） 49 202
  outGoing1: [200, 250], // 中置柜 69 250
  transformer: [130, 200], // 89（100） 200
  gridBilling: [200, 250], // 183（130） 250
  lineGate: [60, 202], // 15 202
  busTie: [220, 250], // 102 250

  voltageVariable1: [200, 139], // 中置柜80 139
  voltageVariable2: [120, 201], //环网柜 54 201

  // 低压
  low_inComing: [200, 282], // 95 282
  low_outGoing: [360, 99], // 155,99
  low_busTie: [240, 250], // 96,250
};

export const nodeSizeMapByString: Record<number, string> = {
  [CircuitType.TRANSFORMER_CIRCUIT]: 'transformer', // 变压器回路
  [CircuitType.GRID_BILLING_CIRCUIT]: 'gridBilling', // 电网计费回路
  [CircuitType.OUTGOING_CIRCUIT]: 'outGoing', // 出线回路
  [CircuitType.INCOMING_CIRCUIT]: 'inComing', // 进线回路
  [CircuitType.LEAD_WIRE_SWITCH_CIRCUIT]: 'lineGate', // 引闸刀回路
  [CircuitType.BUS_COUPLER_CIRCUIT]: 'busTie', // 母联回路
  [CircuitType.VOLTAGE_CONVERSION_CIRCUIT]: 'voltageVariable', // 压变回路
};

// 文字指定宽度换行
function wrapText(text?: string, maxWidth = 120, showLine = true) {
  if (!text) return { text: showLine ? '--' : '', lineCount: 1 };
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  const words = text!.split('');
  const lines = [];
  let currentLine = words[0];
  for (let i = 1; i < words.length; i++) {
    const word = words[i];
    const width = context!.measureText(currentLine + word).width;
    if (width > maxWidth) {
      lines.push(currentLine);
      currentLine = word;
    } else {
      currentLine += word;
    }
  }
  lines.push(currentLine);
  return { text: lines.join('\n'), lineCount: lines.length };
}

export function registerG6() {
  // 进线回路（高压）- 中置柜 - 有父级
  G6.registerNode('inComing_hasP_1', {
    draw: function drawShape(cfg, group) {
      const nodeSize = cfg.size as number[];
      const w = nodeSize[0];
      const h = nodeSize[1];
      const value = cfg?.value as any;
      // 主体框
      const shape = group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: h,
          // stroke: 'red',
        },
        name: 'main-box',
      });

      if (cfg?.hasRedLine) {
        if (value?.position === 'left') {
          group!.addShape('rect', {
            attrs: {
              x: -w / 2,
              y: -h / 2,
              width: w / 2, // 有些许偏差
              height: 2,
              fill: 'red',
              stroke: 'red',
            },
            name: 'left-top-line',
          });
          group!.addShape('rect', {
            attrs: {
              x: 0,
              y: h / 2 - 1, // 有些许偏差
              width: w / 2,
              height: 2,
              fill: 'red',
            },
            name: 'left-bottom-line',
          });
        } else if (value?.position === 'right') {
          group!.addShape('rect', {
            attrs: {
              x: 0,
              y: -h / 2,
              width: w / 2,
              height: 2,
              fill: 'red',
              stroke: 'red',
            },
            name: 'right-top-line',
          });
          group!.addShape('rect', {
            attrs: {
              x: -w / 2,
              y: h / 2 - 1, // 有些许偏差,
              width: w / 2,
              height: 2,
              fill: 'red',
            },
            name: 'right-bottom-line',
          });
        } else {
          group!.addShape('rect', {
            attrs: {
              x: -w / 2,
              y: -h / 2,
              width: w,
              height: 2,
              fill: 'red',
              stroke: 'red',
            },
            name: 'cabinet-box',
          });
        }
      }

      const { text } = wrapText(value?.name);
      const { text: name } = wrapText(value?.name, nodeImgSizeMap[cfg.type!][0]);

      // 名字
      group!.addShape('text', {
        attrs: {
          x: cfg?.hasRedLine ? -nodeImgSizeMap[cfg.type!][0] / 2 : nodeImgSizeMap[cfg.type!][0] / 2 + 10,
          y: cfg?.hasRedLine ? h / 2 + 10 : 0,
          textBaseline: 'top',
          text: cfg?.hasRedLine ? name : text,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 引自引至
      const { text: fromCircuitName } = wrapText(value?.fromCircuitName, 80, false);
      const { text: toCircuitName } = wrapText(value?.toCircuitName, 80, false);

      renderFromTo(w, h, group, fromCircuitName, toCircuitName);

      // 配电柜名字
      group!.addShape('text', {
        attrs: {
          x: -20,
          y: -h / 2 - 10,
          textBaseline: 'bottom',
          text: value?.cabinetName,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 图片
      group!.addShape('image', {
        attrs: {
          x: -nodeImgSizeMap[cfg.type!][0] / 2,
          y: -h / 2,
          width: nodeImgSizeMap[cfg.type!][0],
          height: nodeImgSizeMap[cfg.type!][1],
          img: value?.switchStatus === 1 ? inComing_zz_hasP_close : inComing_zz_hasP_open,
        },
        name: 'img',
      });

      renderCurrentVoltageByV(h, group, cfg.type!, value, -10);

      return shape;
    },
  });

  // 进线回路（高压）- 中置柜 - 无父级
  G6.registerNode('inComing_noP_1', {
    draw: function drawShape(cfg, group) {
      const nodeSize = cfg.size as number[];
      const w = nodeSize[0];
      const h = nodeSize[1];
      const value = cfg?.value as any;
      // 主体框
      const shape = group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: h,
          // stroke: 'red',
        },
        name: 'main-box',
      });

      group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w, // 有些许偏差
          height: 2,
          fill: 'red',
          stroke: 'red',
        },
        name: 'top-line',
      });

      const { text: name } = wrapText(value?.name, nodeImgSizeMap[cfg.type!][0]);

      // 名字
      group!.addShape('text', {
        attrs: {
          x: -nodeImgSizeMap[cfg.type!][0] / 2,
          y: h / 2 - 10,
          textBaseline: 'top',
          text: name,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 引自引至
      const { text: fromCircuitName } = wrapText(value?.fromCircuitName, 80, false);
      const { text: toCircuitName } = wrapText(value?.toCircuitName, 80, false);

      renderFromTo(w, h, group, fromCircuitName, toCircuitName);

      // 配电柜名字
      group!.addShape('text', {
        attrs: {
          x: 30,
          y: -h / 2 - 10,
          textBaseline: 'bottom',
          text: value?.cabinetName,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 图片
      group!.addShape('image', {
        attrs: {
          x: -20,
          y: -h / 2 - 32,
          width: nodeImgSizeMap[cfg.type!][0],
          height: nodeImgSizeMap[cfg.type!][1],
          img: value?.switchStatus === 1 ? inComing_zz_noP_close : inComing_zz_noP_open,
        },
        name: 'img',
      });

      renderCurrentVoltageByV(h, group, cfg.type!, value);

      return shape;
    },
  });

  // 进线回路（高压）- 环网柜
  G6.registerNode('inComing2', {
    draw: function drawShape(cfg, group) {
      const nodeSize = cfg.size as number[];
      const w = nodeSize[0];
      const h = nodeSize[1];
      const value = cfg?.value as any;
      // 主体框
      const shape = group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: h,
          // stroke: 'red',
        },
        name: 'main-box',
      });

      group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w, // 有些许偏差
          height: 2,
          fill: 'red',
          stroke: 'red',
        },
        name: 'top-line',
      });

      const { text } = wrapText(value?.name);
      const { text: name } = wrapText(value?.name, nodeImgSizeMap[cfg.type!][0]);

      // 名字
      group!.addShape('text', {
        attrs: {
          x: cfg?.hasRedLine ? -nodeImgSizeMap[cfg.type!][0] / 2 : nodeImgSizeMap[cfg.type!][0] / 2 + 10,
          y: cfg?.hasRedLine ? h / 2 + 10 : 0,
          textBaseline: 'top',
          text: cfg?.hasRedLine ? name : text,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 引自引至
      const { text: fromCircuitName } = wrapText(value?.fromCircuitName, 80, false);
      const { text: toCircuitName } = wrapText(value?.toCircuitName, 80, false);

      renderFromTo(w, h, group, fromCircuitName, toCircuitName);

      // 配电柜名字
      group!.addShape('text', {
        attrs: {
          x: 30,
          y: -h / 2 - 10,
          textBaseline: 'bottom',
          text: value?.cabinetName,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 图片
      group!.addShape('image', {
        attrs: {
          x: -10,
          y: -h / 2,
          width: nodeImgSizeMap[cfg.type!][0],
          height: nodeImgSizeMap[cfg.type!][1],
          img: value?.switchStatus === 1 ? inComing_hw_close : inComing_hw_open,
        },
        name: 'img',
      });

      // 数据展示
      renderCurrentVoltageByV(h, group, cfg.type!, value);

      return shape;
    },
  });

  // 变压器回路（高压、低压）
  G6.registerNode('transformer', {
    draw: function drawShape(cfg, group) {
      const nodeSize = cfg.size as number[];
      const w = nodeSize[0] ?? 100;
      const h = nodeSize[1] ?? 3;

      const value = cfg?.value as any;
      const { text } = wrapText(value?.name);

      // 主体框
      const shape = group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: h,
          // stroke: 'red',
          fill: 'transparent',
        },
        name: 'main-box',
      });

      // 名字
      group!.addShape('text', {
        attrs: {
          x: nodeImgSizeMap['transformer'][0] / 2 + 10,
          y: 0,
          textBaseline: 'middle',
          text: text,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 引自引至
      const { text: fromCircuitName } = wrapText(value?.fromCircuitName, 80, false);
      const { text: toCircuitName } = wrapText(value?.toCircuitName, 80, false);

      renderFromTo(w, h, group, fromCircuitName, toCircuitName);

      // 图片
      group!.addShape('image', {
        attrs: {
          x: -nodeImgSizeMap['transformer'][0] / 2,
          y: -h / 2,
          width: nodeImgSizeMap['transformer'][0],
          height: nodeImgSizeMap['transformer'][1],
          img: transformer,
        },
        name: 'img',
      });

      renderCurrentVoltageByV(h, group, cfg.type!, value);
      return shape;
    },
  });

  // 电网计费回路（高压、低压）
  G6.registerNode('gridBilling', {
    draw: function drawShape(cfg, group) {
      const nodeSize = cfg.size as number[];
      const w = nodeSize[0] ?? 100;
      const h = nodeSize[1] ?? 3;

      const value = cfg?.value as any;

      // 主体框
      const shape = group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: h,
          fill: 'transparent',
          // stroke: 'red',
        },
        name: 'main-box',
      });

      const { text } = wrapText(value?.name, nodeImgSizeMap['gridBilling'][0]);
      // 名字
      group!.addShape('text', {
        attrs: {
          x: -nodeImgSizeMap['gridBilling'][0] / 2 + 30,
          y: -h / 2 - 10,
          textBaseline: 'bottom',
          text: text,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 引自引至
      const { text: fromCircuitName } = wrapText(value?.fromCircuitName, 80, false);
      const { text: toCircuitName } = wrapText(value?.toCircuitName, 80, false);

      renderFromTo(w, h, group, fromCircuitName, toCircuitName);

      // 图片
      group!.addShape('image', {
        attrs: {
          x: -nodeImgSizeMap['gridBilling'][0] / 2,
          y: -h / 2,
          width: nodeImgSizeMap['gridBilling'][0],
          height: nodeImgSizeMap['gridBilling'][1],
          img: value?.switchStatus === 1 ? gridBilling_close : gridBilling_open,
        },
        name: 'img',
      });

      renderCurrentVoltageByV(h, group, cfg.type!, value, -10);
      return shape;
    },
  });

  // 高压出线回路(中置柜-1)
  G6.registerNode('outGoing1', {
    draw: function drawShape(cfg, group) {
      const nodeSize = cfg.size as number[];
      const w = nodeSize[0] ?? 100;
      const h = nodeSize[1] ?? 3;
      const value = cfg?.value as any;

      // 主体框
      const shape = group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: h,
          fill: 'transparent',
          // stroke: 'red',
        },
        name: 'main-box',
      });

      group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: 2,
          fill: 'red',
          stroke: 'red',
        },
        name: 'cabinet-box',
      });

      const { text } = wrapText(value?.name, nodeImgSizeMap[cfg.type!][0]);
      // 名字
      group!.addShape('text', {
        attrs: {
          x: -nodeImgSizeMap[cfg.type!][0] / 2,
          y: -h / 2 + nodeImgSizeMap[cfg.type!][1] + 10,
          textBaseline: 'top',
          text: text,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 配电柜名字
      group!.addShape('text', {
        attrs: {
          x: 10,
          y: -h / 2 - 10,
          textBaseline: 'bottom',
          text: value?.cabinetName,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      const { text: fromCircuitName } = wrapText(value?.fromCircuitName, 80, false);
      const { text: toCircuitName } = wrapText(value?.toCircuitName, 80, false);

      renderFromTo(w, h, group, fromCircuitName, toCircuitName);

      // 图片
      group!.addShape('image', {
        attrs: {
          x: -10,
          y: -h / 2,
          width: nodeImgSizeMap[cfg.type!][0],
          height: nodeImgSizeMap[cfg.type!][1],
          img: value?.switchStatus === 1 ? outGoing_close_2 : outGoing_open_2,
        },
        name: 'img',
      });

      renderCurrentVoltageByV(h, group, cfg.type!, value);

      return shape;
    },
  });

  // 高压出线回路(环网柜-2)
  G6.registerNode('outGoing2', {
    draw: function drawShape(cfg, group) {
      const nodeSize = cfg.size as number[];
      const w = nodeSize[0] ?? 100;
      const h = nodeSize[1] ?? 3;
      const value = cfg?.value as any;

      // 主体框
      const shape = group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: h,
          fill: 'transparent',
          // stroke: 'red',
        },
        name: 'main-box',
      });

      group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: 2,
          fill: 'red',
          stroke: 'red',
        },
        name: 'cabinet-box',
      });

      const { text } = wrapText(value?.name, w - 100);
      // 名字
      group!.addShape('text', {
        attrs: {
          x: -nodeImgSizeMap[cfg.type!][0] / 2,
          y: -h / 2 + nodeImgSizeMap[cfg.type!][1] + 20,
          textBaseline: 'middle',
          text: text,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 引自引至
      const { text: fromCircuitName } = wrapText(value?.fromCircuitName, 80, false);
      const { text: toCircuitName } = wrapText(value?.toCircuitName, 80, false);

      renderFromTo(w, h, group, fromCircuitName, toCircuitName);

      // 配电柜名字
      group!.addShape('text', {
        attrs: {
          x: 10,
          y: -h / 2 - 10,
          textBaseline: 'bottom',
          text: value?.cabinetName,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'cabinet-name',
      });

      // 图片
      group!.addShape('image', {
        attrs: {
          x: -10,
          y: -h / 2,
          width: nodeImgSizeMap[cfg.type!][0],
          height: nodeImgSizeMap[cfg.type!][1],
          img: value?.switchStatus === 1 ? outGoing_close : outGoing_open,
        },
        name: 'img',
      });

      renderCurrentVoltageByV(h, group, cfg.type!, value);

      return shape;
    },
  });

  // 高压引闸刀回路
  G6.registerNode('lineGate', {
    draw: function drawShape(cfg, group) {
      const nodeSize = cfg.size as number[];
      const w = nodeSize[0] ?? 100;
      const h = nodeSize[1] ?? 3;
      const value = cfg?.value as any;

      // 主体框
      const shape = group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: h,
          fill: 'transparent',
          // stroke: 'red',
        },
        name: 'main-box',
      });

      const { text } = wrapText(value?.name);
      // 名字
      group!.addShape('text', {
        attrs: {
          x: w / 2 + 10,
          y: -h / 2 + nodeImgSizeMap['lineGate'][1] / 2,
          textBaseline: 'middle',
          text: text,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 图片
      group!.addShape('image', {
        attrs: {
          x: -nodeImgSizeMap['lineGate'][0] / 2,
          y: -h / 2,
          width: nodeImgSizeMap['lineGate'][0],
          height: nodeImgSizeMap['lineGate'][1],
          img: value?.switchStatus === 1 ? lineGate_high_close : lineGate_high_open,
        },
        name: 'img',
      });

      if ((cfg?.extend as any)?.hasExtend) {
        group!.addShape('rect', {
          attrs: {
            x: -1,
            y: h / 2,
            width: 2,
            height: nodeImgSizeMap[(cfg?.extend as any)?.extendLineType][1],
            fill: 'red',
            // stroke: 'red',
          },
          name: 'main-box',
        });
      }

      return shape;
    },
  });

  // 高压母联回路
  G6.registerNode('busTie', {
    draw: function drawShape(cfg, group) {
      const nodeSize = cfg.size as number[];
      const w = nodeSize[0] ?? 100;
      const h = nodeSize[1] ?? 3;

      const value = cfg?.value as any;

      // 主体框
      const shape = group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: h,
          fill: 'transparent',
          // stroke: 'red',
        },
        name: 'main-box',
      });

      // 上面两条横线（一）
      group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: 140,
          height: 2,
          fill: 'red',
          stroke: 'red',
        },
        name: 'cabinet-box',
      });
      // 上面两条横线（二）
      group!.addShape('rect', {
        attrs: {
          x: 70,
          y: -h / 2,
          width: w / 2 - 70,
          height: 2,
          fill: 'red',
          stroke: 'red',
        },
        name: 'cabinet-box',
      });

      const { text: fromCircuitName } = wrapText(value?.fromCircuitName, 80, false);
      const { text: toCircuitName } = wrapText(value?.toCircuitName, 80, false);

      renderFromTo(w, h, group, fromCircuitName, toCircuitName);

      const { text } = wrapText(value?.name, nodeImgSizeMap[cfg.type!][0]);
      // 名字
      group!.addShape('text', {
        attrs: {
          x: -nodeImgSizeMap[cfg.type!][0] / 2,
          y: -h / 2 + nodeImgSizeMap[cfg.type!][1] + 10,
          textBaseline: 'top',
          text: text,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 配电柜名字
      group!.addShape('text', {
        attrs: {
          x: -30,
          y: -h / 2 - 10,
          textBaseline: 'bottom',
          text: value?.cabinetName,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'cabinet-name',
      });

      const renderImg = () => {
        if (value?.switchType === 2) {
          // 带隔离
          if (value?.switchStatus === 1) {
            // 合闸
            return busTie_high_qua_close;
          } else {
            return busTie_high_qua_open;
          }
        } else {
          if (value?.switchStatus === 1) {
            return busTie_high_noqua_close;
          } else {
            return busTie_high_noqua_open;
          }
        }
      };

      // 图片
      group!.addShape('image', {
        attrs: {
          x: -10,
          y: -h / 2,
          width: nodeImgSizeMap[cfg.type!][0],
          height: nodeImgSizeMap[cfg.type!][1],
          img: renderImg(),
        },
        name: 'img',
      });

      renderCurrentVoltageByV(h, group, cfg.type!, value);

      return shape;
    },
  });

  // 高压压变回路（中置柜）
  G6.registerNode('voltageVariable1', {
    draw: function drawShape(cfg, group) {
      const nodeSize = cfg.size as number[];
      const w = nodeSize[0] ?? 100;
      const h = nodeSize[1] ?? 3;
      const value = cfg?.value as any;

      // 主体框
      const shape = group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: h,
          fill: 'transparent',
          // stroke: 'red',
        },
        name: 'main-box',
      });

      group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: 2,
          fill: 'red',
          stroke: 'red',
        },
        name: 'cabinet-box',
      });

      const { text } = wrapText(value?.name, nodeImgSizeMap[cfg.type!][0]);

      // 名字
      group!.addShape('text', {
        attrs: {
          x: -nodeImgSizeMap[cfg.type!][0] / 2,
          y: -h / 2 + nodeImgSizeMap[cfg.type!][1] + 10,
          textBaseline: 'top',
          text: text,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 引自引至
      const { text: fromCircuitName } = wrapText(value?.fromCircuitName, 80, false);
      const { text: toCircuitName } = wrapText(value?.toCircuitName, 80, false);

      renderFromTo(w, h, group, fromCircuitName, toCircuitName);

      // 配电柜名字
      group!.addShape('text', {
        attrs: {
          x: -nodeImgSizeMap[cfg.type!][0] / 2,
          y: -h / 2 - 10,
          textBaseline: 'bottom',
          text: value?.cabinetName,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 图片
      group!.addShape('image', {
        attrs: {
          x: -nodeImgSizeMap[cfg.type!][0] / 2,
          y: -h / 2,
          width: nodeImgSizeMap[cfg.type!][0],
          height: nodeImgSizeMap[cfg.type!][1],
          img: voltageVariable_zz,
        },
        name: 'img',
      });
      return shape;
    },
  });

  // 高压压变回路（环网柜）
  G6.registerNode('voltageVariable2', {
    draw: function drawShape(cfg, group) {
      const nodeSize = cfg.size as number[];
      const w = nodeSize[0] ?? 100;
      const h = nodeSize[1] ?? 3;
      const value = cfg?.value as any;

      // 主体框
      const shape = group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: h,
          fill: 'transparent',
          // stroke: 'red',
        },
        name: 'main-box',
      });

      group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: 2,
          fill: 'red',
          stroke: 'red',
        },
        name: 'cabinet-box',
      });

      // const { text } = wrapText(value?.name, nodeImgSizeMap[cfg.type!][0]);
      const { text } = wrapText(value?.name, nodeImgSizeMap[cfg.type!][0]);
      // 名字
      group!.addShape('text', {
        attrs: {
          x: -20,
          y: -h / 2 + nodeImgSizeMap[cfg.type!][1] + 10,
          textBaseline: 'top',
          text: text,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 引自引至
      const { text: fromCircuitName } = wrapText(value?.fromCircuitName, 80, false);
      const { text: toCircuitName } = wrapText(value?.toCircuitName, 80, false);

      renderFromTo(w, h, group, fromCircuitName, toCircuitName);

      // 配电柜名字
      group!.addShape('text', {
        attrs: {
          x: 10,
          y: -h / 2 - 10,
          textBaseline: 'bottom',
          text: value?.cabinetName,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 图片
      group!.addShape('image', {
        attrs: {
          x: -20,
          y: -h / 2,
          width: nodeImgSizeMap[cfg.type!][0],
          height: nodeImgSizeMap[cfg.type!][1],
          img: value?.switchStatus === 1 ? voltageVariable_hw_close : voltageVariable_hw_open,
        },
        name: 'img',
      });
      return shape;
    },
  });

  // 低压进线回路
  G6.registerNode('low_inComing', {
    draw: function drawShape(cfg, group) {
      const nodeSize = cfg.size as number[];
      const w = nodeSize[0];
      const h = nodeSize[1];
      const value = cfg?.value as any;
      // 主体框
      const shape = group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: h,
          // stroke: 'red',
        },
        name: 'main-box',
      });

      const { text: name } = wrapText(value?.name, nodeImgSizeMap[cfg.type!][0]);

      if (cfg?.hasRedLine) {
        group!.addShape('rect', {
          attrs: {
            x: -w / 2,
            y: -h / 2,
            width: w, // 有些许偏差
            height: 2,
            fill: 'red',
            stroke: 'red',
          },
          name: 'top-line',
        });
      }

      // 名字
      group!.addShape('text', {
        attrs: {
          x: -nodeImgSizeMap[cfg.type!][0] / 2,
          y: h / 2 - 10,
          textBaseline: 'top',
          text: name,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      const { text: fromCircuitName } = wrapText(value?.fromCircuitName, 80, false);
      const { text: toCircuitName } = wrapText(value?.toCircuitName, 80, false);

      renderFromTo(w, h, group, fromCircuitName, toCircuitName);

      // 配电柜名字
      group!.addShape('text', {
        attrs: {
          x: -10,
          y: -h / 2 - 10,
          textBaseline: 'bottom',
          textAlign: 'right',
          text: value?.cabinetName,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 图片
      group!.addShape('image', {
        attrs: {
          x: -20,
          y: -h / 2 - 31, // 有引线箭头
          width: nodeImgSizeMap[cfg.type!][0],
          height: nodeImgSizeMap[cfg.type!][1],
          img: value?.switchStatus === 1 ? low_inComing_close : low_inComing_open,
        },
        name: 'img',
      });

      renderCurrentVoltageByV(h, group, cfg.type!, value);

      return shape;
    },
  });

  // 低压出线回路
  G6.registerNode('low_outGoing', {
    draw: function drawShape(cfg, group) {
      const nodeSize = cfg.size as number[];
      const w = nodeSize[0];
      const h = nodeSize[1];
      const value = cfg?.value as any;
      // 主体框
      const shape = group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: h,
          // stroke: 'red',
        },
        name: 'main-box',
      });

      const { text: name } = wrapText(value?.name, 90);

      if (cfg?.hasRedLine) {
        group!.addShape('rect', {
          attrs: {
            x: -w / 2,
            y: -h / 2,
            width: w, // 有些许偏差
            height: 2,
            fill: 'red',
            stroke: 'red',
          },
          name: 'top-line',
        });
      }

      // 名字
      group!.addShape('text', {
        attrs: {
          x: -w / 2 + 6,
          y: -h / 2 + 10,
          textBaseline: 'top',
          text: name,
          fontSize: 10,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 引自引至
      const { text: fromCircuitName } = wrapText(value?.fromCircuitName, 80, false);
      const { text: toCircuitName } = wrapText(value?.toCircuitName, 80, false);

      renderFromTo(w, h, group, fromCircuitName, toCircuitName);

      // 配电柜名字
      group!.addShape('text', {
        attrs: {
          x: -w / 2,
          y: -h / 2 - 10,
          textBaseline: 'bottom',
          text: value?.cabinetName,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      const renderImg = () => {
        if (value?.switchType === 1) {
          // 断路器
          if (value?.switchStatus === 1) {
            // 合闸
            return low_outGoing_breaker_close;
          } else {
            return low_outGoing_breaker_open;
          }
        } else {
          // 开关
          if (value?.switchStatus === 1) {
            return low_outGoing_switch_close;
          } else {
            return low_outGoing_switch_open;
          }
        }
      };

      // 图片
      group!.addShape('image', {
        attrs: {
          // x: -nodeImgSizeMap[cfg.type!][0] / 2,
          x: -w / 2,
          y: -h / 2,
          width: nodeImgSizeMap[cfg.type!][0],
          height: nodeImgSizeMap[cfg.type!][1],
          img: renderImg(),
        },
        name: 'img',
      });

      // 三项电压电流
      renderCurrentVoltageByH(w, h, group, cfg.type!, value);

      return shape;
    },
  });

  // 低压母联回路
  G6.registerNode('low_busTie', {
    draw: function drawShape(cfg, group) {
      const nodeSize = cfg.size as number[];
      const w = nodeSize[0] ?? 100;
      const h = nodeSize[1] ?? 3;

      const value = cfg?.value as any;

      // 主体框
      const shape = group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w,
          height: h,
          fill: 'transparent',
          // stroke: 'red',
        },
        name: 'main-box',
      });

      // 上面两条横线（一）
      group!.addShape('rect', {
        attrs: {
          x: -w / 2,
          y: -h / 2,
          width: w / 2 + 30,
          height: 2,
          fill: 'red',
          stroke: 'red',
        },
        name: 'cabinet-box1',
      });
      // 上面两条横线（二）
      group!.addShape('rect', {
        attrs: {
          x: 70,
          y: -h / 2,
          width: w / 2 - 70,
          height: 2,
          fill: 'red',
          stroke: 'red',
        },
        name: 'cabinet-box2',
      });

      const { text } = wrapText(value?.name, nodeImgSizeMap[cfg.type!][0]);
      // 名字
      group!.addShape('text', {
        attrs: {
          x: 20,
          y: -h / 2 + nodeImgSizeMap[cfg.type!][1] + 10,
          textBaseline: 'top',
          text: text,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 配电柜名字
      group!.addShape('text', {
        attrs: {
          x: 0,
          y: -h / 2 - 10,
          textBaseline: 'bottom',
          textAlign: 'right',
          text: value?.cabinetName,
          fill: 'rgba(255,255,255,0.85)',
        },
        name: 'name',
      });

      // 引自引至
      const { text: fromCircuitName } = wrapText(value?.fromCircuitName, 80, false);
      const { text: toCircuitName } = wrapText(value?.toCircuitName, 80, false);

      renderFromTo(w, h, group, fromCircuitName, toCircuitName);

      // 图片
      group!.addShape('image', {
        attrs: {
          // x: -nodeImgSizeMap[cfg.type!][0] / 2,
          x: -10,
          y: -h / 2,
          width: nodeImgSizeMap[cfg.type!][0],
          height: nodeImgSizeMap[cfg.type!][1],
          img: value?.switchStatus === 1 ? low_busTie_close : low_busTie_open,
        },
        name: 'img',
      });

      renderCurrentVoltageByV(h, group, cfg.type!, value);
      return shape;
    },
  });
}

// 水平的三项电压电流
const renderCurrentVoltageByH = (w: number, h: number, group: IGroup, type: string, value: any) => {
  if (value.hasDevice) {
    group!.addShape('text', {
      attrs: {
        x: -w / 2 + nodeImgSizeMap[type!][0] + 10,
        y: -h / 2 + 15,
        width: 10,
        textBaseline: 'top',
        text: keepTwoOrEmpty(value?.currentA) + 'A',
        fill: '#FFC53D',
      },
      name: 'currentA',
    });
    group!.addShape('text', {
      attrs: {
        x: -w / 2 + nodeImgSizeMap[type!][0] + 10,
        y: -h / 2 + 40,
        width: 10,
        textBaseline: 'top',
        text: keepTwoOrEmpty(value?.currentB) + 'A',
        fill: '#52C41A',
      },
      name: 'currentB',
    });
    group!.addShape('text', {
      attrs: {
        x: -w / 2 + nodeImgSizeMap[type!][0] + 10,
        y: -h / 2 + 65,
        width: 10,
        textBaseline: 'top',
        text: keepTwoOrEmpty(value?.currentC) + 'A',
        fill: '#E64242',
      },
      name: 'currentC',
    });

    group!.addShape('text', {
      attrs: {
        x: -w / 2 + nodeImgSizeMap[type!][0] + 110,
        y: -h / 2 + 15,
        width: 10,
        textBaseline: 'top',
        text: keepTwoOrEmpty(value?.voltageA) + 'V',
        fill: '#FFC53D',
      },
      name: 'voltageA',
    });
    group!.addShape('text', {
      attrs: {
        x: -w / 2 + nodeImgSizeMap[type!][0] + 110,
        y: -h / 2 + 40,
        width: 10,
        textBaseline: 'top',
        text: keepTwoOrEmpty(value?.voltageB) + 'V',
        fill: '#52C41A',
      },
      name: 'voltageB',
    });
    group!.addShape('text', {
      attrs: {
        x: -w / 2 + nodeImgSizeMap[type!][0] + 110,
        y: -h / 2 + 65,
        width: 10,
        textBaseline: 'top',
        text: keepTwoOrEmpty(value?.voltageC) + 'V',
        fill: '#E64242',
      },
      name: 'voltageC',
    });
  }
};

// 垂直的三项电压电流
const renderCurrentVoltageByV = (h: number, group: IGroup, type: string, value: any, xOffset = 0) => {
  if (value.hasDevice) {
    group!.addShape('text', {
      attrs: {
        x: -30 + xOffset,
        y: -h / 2 + 30,
        width: 10,
        textBaseline: 'top',
        textAlign: 'right', // ← 右对齐
        text: keepTwoOrEmpty(value?.currentA) + 'A',
        fill: '#FFC53D',
      },
      name: 'currentA',
    });
    group!.addShape('text', {
      attrs: {
        x: -30 + xOffset,
        y: -h / 2 + 55,
        width: 10,
        textBaseline: 'top',
        textAlign: 'right', // ← 右对齐
        text: keepTwoOrEmpty(value?.currentB) + 'A',
        fill: '#52C41A',
      },
      name: 'currentB',
    });
    group!.addShape('text', {
      attrs: {
        x: -30 + xOffset,
        y: -h / 2 + 80,
        width: 10,
        textBaseline: 'top',
        textAlign: 'right', // ← 右对齐
        text: keepTwoOrEmpty(value?.currentC) + 'A',
        fill: '#E64242',
      },
      name: 'currentC',
    });

    group!.addShape('text', {
      attrs: {
        x: -30 + xOffset,
        y: -h / 2 + 105,
        width: 10,
        textBaseline: 'top',
        textAlign: 'right', // ← 右对齐
        text: keepTwoOrEmpty(value?.voltageA) + 'V',
        fill: '#FFC53D',
      },
      name: 'voltageA',
    });
    group!.addShape('text', {
      attrs: {
        x: -30 + xOffset,
        y: -h / 2 + 130,
        width: 10,
        textBaseline: 'top',
        textAlign: 'right', // ← 右对齐
        text: keepTwoOrEmpty(value?.voltageB) + 'V',
        fill: '#52C41A',
      },
      name: 'voltageB',
    });
    group!.addShape('text', {
      attrs: {
        x: -30 + xOffset,
        y: -h / 2 + 155,
        width: 10,
        textBaseline: 'top',
        textAlign: 'right', // ← 右对齐
        text: keepTwoOrEmpty(value?.voltageC) + 'V',
        fill: '#E64242',
      },
      name: 'voltageC',
    });
  }
};

const renderFromTo = (w: number, h: number, group: IGroup, fromCircuitName: string, toCircuitName: string) => {
  // 引自
  group!.addShape('text', {
    attrs: {
      x: -w / 2 - 20,
      y: -h / 2 - 28,
      textBaseline: 'bottom',
      text: fromCircuitName,
      fill: 'rgba(255,255,255,0.85)',
    },
    name: 'fromCircuitName',
  });
  // 引至
  group!.addShape('text', {
    attrs: {
      x: w / 2,
      y: -h / 2 - 6,
      textBaseline: 'bottom',
      text: toCircuitName,
      fill: 'rgba(255,255,255,0.85)',
    },
    name: 'toCircuitName',
  });
};
